import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ae867694"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "slider-tovar"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "slider-tovar__inner"
};
const _hoisted_4 = {
  class: "swiper-object-3"
};
const _hoisted_5 = {
  class: "navigation"
};
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Card = _resolveComponent("Card");
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_swiper, {
    ref: "mySwiper",
    class: "slider-tovar__box",
    modules: $setup.modules,
    "slides-per-view": 4,
    "slides-per-group": 4,
    "space-between": 20,
    onSwiper: $setup.onSwiper
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.slides, item => {
      return _openBlock(), _createBlock(_component_swiper_slide, {
        key: item.id
      }, {
        default: _withCtx(() => [_createVNode(_component_Card, {
          id: item.id,
          title: item.title,
          weight: item.weight,
          volume: item.volume,
          composition: item.composition,
          price: item.price,
          imgUrl: item.imgUrl,
          isHit: item.isHit,
          isNew: item.isNew,
          filter_1: item.filter_1,
          filter_2: item.filter_2,
          filter_3: item.filter_3,
          "is-favorite": item.isFavorite,
          "is-added": item.isAdded,
          category: item.category,
          "on-click-favorite": () => _ctx.$emit('addToFavorite', item),
          "on-click-add": () => _ctx.$emit('addToCart', item),
          class: "card-item"
        }, null, 8, ["id", "title", "weight", "volume", "composition", "price", "imgUrl", "isHit", "isNew", "filter_1", "filter_2", "filter_3", "is-favorite", "is-added", "category", "on-click-favorite", "on-click-add"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["modules", "onSwiper"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
    class: "swiper-button-next",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('onSlideChangeNext', 'next', $setup.swiper)),
    disabled: $props.pageNumber == $props.totalPages
  }, null, 8, _hoisted_6), _createElementVNode("button", {
    class: "swiper-button-prev",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('onSlideChangePrev', 'prev', $setup.swiper)),
    disabled: $props.pageNumber == 1
  }, null, 8, _hoisted_7)])])])])]);
}